import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from 'Components/UI/Typography';
import Switch from 'Components/ComponentLibrary/Components/Uncategorized/Switch';

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
  },
  title: {
    flexBasis: '70%',
    flexGrow: 1,
  },
});

const YesNoQuestion = ({
  classes,
  className,
  value,
  onChange,
  label,
  fullWidth,
  ...rest
}) => {
  const handleChange = (e) => {
    e.target.checked = !value;
    return onChange(e);
  };
  return (
    <div className={classNames(classes.root, className)} {...rest}>
      <Typography variant="h6" className={classes.title}>
        {label}
      </Typography>
      <Switch
        selected={value}
        onChange={handleChange}
      />
      <input hidden value={value} onClick={onChange} />
    </div>
  );
};

YesNoQuestion.defaultProps = {
  classes: {},
  className: '',
  fullWidth: false,
  value: null,
};

YesNoQuestion.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  value: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
};

export default withStyles(styles)(YesNoQuestion);
